import { createStyles, makeStyles } from '@material-ui/core';
import { Sizes } from '../../../../styles/sizes';
import { colorVariables } from '../../../../styles/colorVariables';

export const useStyles = makeStyles((theme) =>
  createStyles({
    services: {
      textAlign: 'center',
      margin: '0 auto',
      justifyContent: 'center',
      alignItems: 'center',
      [theme.breakpoints.down(Sizes.mobile)]: {
        display: 'block',
      },
    },
    serviceItem: {
      width: '100%',
      [theme.breakpoints.down(Sizes.mobile)]: {
        marginBottom: 20,
      },
    },
    serviceAction: {
      '&.MuiCardActions-root': {
        display: 'block',
        padding: 0,
      }
    },
    logo: {
      minHeight: 65,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    logoText: {
      minHeight: 12,
      fontSize: 12,
      fontWeight: 300,
      height: 38,
      padding: '0 16px',
    },
    logoText2: {
      fontSize: 14,
      fontWeight: 600,
      height: 38,
    },
    logoBtn: {
      marginTop: 10,
    },
    contactUs: {
      textAlign: 'center',
      marginTop: 100,
    },
    connected: {
      backgroundColor: colorVariables.blue,
      color: '#fff',
      '&:hover': {
        backgroundColor: colorVariables.blue,
      }
    },
    card: {
      width: 216,
      marginRight: 10,
      marginBottom: 20,
      background: '#fff',
      border: '1px solid rgba(152, 165, 183, 0.15)',
      boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.05)',
      borderRadius: 10,
      paddingBottom: 16,
      '& .MuiCardContent-root': {
        padding: 0,
      },
      [theme.breakpoints.down(Sizes.mobile)]: {
        width: '100%',
        paddingBottom: 0,
      },
    },
    myobBtns: {
      position: 'relative',
      '& svg': {
        position: 'absolute',
        top: '14px',
        right: '14px',
      }
    },
    link: {
      color: colorVariables.blue,
      textDecoration: 'none',
    },
    revokeTooltip: {
      top: '-34px',
      left: '80px',
    }
  }),
);
